// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_1DB","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_3W2 FallbackBulkDownloadUpsellModalControl-cls1_1DB"};